import { render, staticRenderFns } from "./Procedura.vue?vue&type=template&id=99fd4c1a&scoped=true&"
import script from "./Procedura.vue?vue&type=script&lang=js&"
export * from "./Procedura.vue?vue&type=script&lang=js&"
import style0 from "./Procedura.vue?vue&type=style&index=0&id=99fd4c1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fd4c1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VContainer,VImg})
